<template>
  <div class="count">
    <button class="round blue" @click="$emit('input', value < 1 ? 0 : value - 1)" :class="{hidden: !(focused || value > 0)}">−</button>
    <input v-model.number="value" type="number" step="1" pattern="[0-9]*" :class="{hidden: !(focused || value > 0)}" @focus="focused = true" @blur="focused = false"/>
    <button class="round blue" @click="$emit('input', value + 1)">+</button>
  </div>
</template>
<script>
  export default {
    name: 'count-buttons',
    props: {
      value: {
        type: Number
      },
    },
    data () {
      return {
        focused: false
      }
    },
  }
</script>
<style scoped lang="sass">
  .count
    flex-shrink: 0
</style>
